/// <reference path="index.d.ts" />
import * as React from 'react';
import doLog from '../../common/log';
import MainLayout from './main-layout';
import MainDialog from './main-dialog';
import './index.scss';

const { useState,Fragment } = React;

function MainImage ( props: PropsInterface ) {
  const [sliderIndex,setSliderIndex] = useState( {
    visibleId: -1,
    tabIndex: 0
  } );

  const hanldeDialog = ( index: number ) => {
    doLog(
      '/sc.details.commonLogs',
      'action=openMainImageDialog',
    );
    setSliderIndex( {
      tabIndex: 0,
      visibleId: index
    } )
  };

  return (
    <Fragment>
      <MainLayout {...props} clickDialog={hanldeDialog} />
      <MainDialog {...props} sliderIndex={sliderIndex} setSliderIndex={setSliderIndex} />
    </Fragment>
  );
}

export default MainImage;
